import { Inject, Optional } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';

export class CustomLuxonDateAdapter extends LuxonDateAdapter {
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
    }

    getFirstDayOfWeek(): number {
        return 0; // Sunday
    }
}
